<template>
<div>
    <show-goods-table :goods-list="goodsList"  :isForm="true"  :class="$style['promotion-form-table']" :firstColumnPrice="false">
        <template>
            <el-table-column label="商品规格">
                <template slot-scope="scope">
                    {{scope.row.specifications.name}}
                </template>
            </el-table-column>
            <el-table-column label="价格（元）">
                <template slot-scope="scope">
                    {{scope.row.final_price_no_sign}}
                </template>
            </el-table-column>
            <el-table-column label="触发脐荐康奖励">
                <template  slot-scope="scope">
                   <el-switch v-model="scope.row.bringNewReward"></el-switch>
                </template>
            </el-table-column>
             <!-- <el-table-column label="给购买者发放奖券">
                <template  slot-scope="scope">
                   <el-switch v-model="scope.row.buyerTicketsReward"></el-switch>
                </template>
            </el-table-column>
             <el-table-column label="给分享者发放奖券">
                <template  slot-scope="scope">
                   <el-switch v-model="scope.row.sharerTicketsReward"></el-switch>
                </template>
            </el-table-column> -->
            <!-- <el-table-column label="优惠劵内容">

            </el-table-column>
            <el-table-column label="发放数量">

            </el-table-column> -->
        </template>
    </show-goods-table>
</div>
</template>
<script>
import showGoodsTable from '../show-goods-table'
export default {
  components: {
    showGoodsTable
  },
  props: {
    value: {
      type: Array,
      default: function () {
        return []
      }
    },
    customerType: {
      type: String,
      default: null
    }
  },
  computed: {
    is_dialog: {
      get: function () {
        return this.is_select_coupon
      },
      set: function (val) {
        this.is_select_coupon = val
      }
    }
  },
  data () {
    return {
      itemId: null,
      is_select_coupon: false,
      dialog_title: '选择优惠劵',
      coupon_list: null,
      goodsId: null,
      goodsList: JSON.parse(JSON.stringify(this.value))
    }
  },
  watch: {
    customerType (val) {
      this.goodsList.forEach(item => {
        if (item.specifications.itemId === this.itemId) {
          if (val === 'buyer') {
            this.$set(item, 'buyerCouponsBack', this.coupon_list)
          } else if (val === 'shower') {
            this.$set(item, 'sharerCouponsBack', this.coupon_list)
          }
        }
      })
    },
    goodsList: {
      handler: function (val) {
        this.$emit('selelctGoods', val)
        // this.$emit('input', val)
      }
    },
    value: {
      handler: function (val) {
        this.$set(this, 'goodsList', val)
      },
      immediate: true
    }
  },
  methods: {
  },
  created () {
    console.log('goodsList', this.value)
  }
}
</script>
<style module lang="less">
.promotion-form-table{
margin-top: 20px;
padding:0;
background:#fff
}
.has-list-add-button{
    margin-bottom: 10px;
}
</style>
